"use client"

import type { ComponentType } from "react"
import DatabaseFixturesPytestPost from "@/content/blog/posts/database-fixtures-pytest-seed-state.mdx"
import GenerateTestDataLocalAiPost from "@/content/blog/posts/generate-test-data-local-ai-mcp.mdx"
import GenerateTestDataPost from "@/content/blog/posts/generate-test-data-with-ai-mcp.mdx"
import HowToResetPost from "@/content/blog/posts/how-to-reset-database-e2e-api-testing.mdx"
import PlaywrightPost from "@/content/blog/posts/seed-postgres-before-playwright-tests.mdx"
import MysqlPost from "@/content/blog/posts/test-data-management-mysql.mdx"
import WelcomePost from "@/content/blog/posts/welcome-to-seedmancer.mdx"
import SchemaDriftPost from "@/content/blog/posts/what-is-schema-drift-how-to-catch-it.mdx"
import SeedScriptsPost from "@/content/blog/posts/why-seed-scripts-fail-at-scale.mdx"

const COMPONENTS: Record<string, ComponentType> = {
  "database-fixtures-pytest-seed-state": DatabaseFixturesPytestPost,
  "generate-test-data-local-ai-mcp": GenerateTestDataLocalAiPost,
  "generate-test-data-with-ai-mcp": GenerateTestDataPost,
  "how-to-reset-database-e2e-api-testing": HowToResetPost,
  "seed-postgres-before-playwright-tests": PlaywrightPost,
  "test-data-management-mysql": MysqlPost,
  "welcome-to-seedmancer": WelcomePost,
  "what-is-schema-drift-how-to-catch-it": SchemaDriftPost,
  "why-seed-scripts-fail-at-scale": SeedScriptsPost
}

export function BlogMdxBody({ slug }: { slug: string }) {
  const Comp = COMPONENTS[slug]
  if (!Comp) return null
  return <Comp />
}
